import request from '@/utils/request'
// 团队
export function myTeam(id) {
    return request({
        url: 'api/usercenter/myTeam',
        method: 'get',
        params:{id}
    })
}